'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useRef } from 'react';
import { useDragAndDrop } from './file-dropzone.hooks.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { Typography } from '../typography/typography.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(e, o) {
    if (null == e) return {};
    var r, t, n = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(t = 0; t < i.length; t++)r = i[t], !(o.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var r, t, n = {}, i = Object.keys(e);
    for(t = 0; t < i.length; t++)r = i[t], o.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let m = {
    note: t.string.isRequired,
    dropNote: t.string.isRequired,
    multiFileErrorMessage: t.string.isRequired
};
const FileDropzone = renderWithRef('FileDropzone', m, (r, i)=>{
    useComponentStylesLoaded('FileDropzone', SWAN_STYLE_KEY_MAP.fileDropzone);
    let { children: m, note: f, dropNote: u, multiFileErrorMessage: h } = r, b = _object_without_properties(r, [
        "children",
        "note",
        "dropNote",
        "multiFileErrorMessage"
    ]), y = new Set([
        'swan-file-dropzone'
    ]), w = useRef(null), { isDragging: _, isMultiDropError: g } = useDragAndDrop(w);
    return _ && y.add('swan-file-dropzone-on-drag'), g && y.add('swan-file-dropzone-has-multi-file-error'), jsxs(RenderComp, {
        classNames: y,
        root: "div",
        forwardedRef: assignRefs(i, w),
        props: b,
        children: [
            m,
            jsx(Typography, {
                className: "swan-file-dropzone-note",
                children: f
            }),
            jsxs("div", {
                className: "swan-file-dropzone-drop-note",
                children: [
                    jsx(Icon, {
                        iconType: "add"
                    }),
                    jsx(Typography, {
                        fontSkin: "body-standard-bold",
                        children: u
                    })
                ]
            }),
            jsxs("div", {
                className: "swan-file-dropzone-error-message",
                children: [
                    jsx(Icon, {
                        iconType: "error"
                    }),
                    jsx(Typography, {
                        fontSkin: "body-standard-bold",
                        children: h
                    })
                ]
            })
        ]
    });
});

export { FileDropzone };
